import { unitMetaFromUnits } from './expensesCsv';
import {
  borneExpensesFromItems,
  buildOwnerPayoutWaterfall,
  expenseItemsFromReport,
} from './payoutV2/mapReportToCard';

const csvMoney = n => Number(Number(n) || 0).toFixed(2);

const ownerNameOf = report => {
  const data = (report && report.ownedByData) || {};
  const populated = report && report.ownedBy && typeof report.ownedBy === 'object' ? report.ownedBy : null;
  return (
    (report && report.ownerName) ||
    data.name ||
    data.fullName ||
    (populated && (populated.name || [populated.firstName, populated.lastName].filter(Boolean).join(' '))) ||
    ''
  );
};

const OPTIONAL_COLUMNS = ['Administrative Charges', 'Host Charge', 'Host Charge (Hidden)'];

export const mapOwnerHostProfitCsvRows = (reports, { units, propertyName } = {}) => {
  const unitMeta = unitMetaFromUnits(units);
  const rows = (reports || []).map(report => {
    const pkg = (report && report.servicePackageData) || {};
    const ownerShareRaw =
      report && report.effectiveOwnerSharePercentage != null
        ? report.effectiveOwnerSharePercentage
        : pkg.ownerSharePercentage;
    const totalRevenue = Number(report && report.totalRevenue) || 0;
    const totalExpenses = Number(report && report.totalExpenses) || 0;
    const groupingType = pkg.groupingType === 'individual' ? 'individual' : 'pool';
    const expenseBuckets = borneExpensesFromItems(
      expenseItemsFromReport(report && report.expenses, {
        unitId: report && (report.unit || report.unitId),
        groupingType,
        expensesSetting: pkg.expensesSetting,
      }),
      totalExpenses
    );
    const waterfall = buildOwnerPayoutWaterfall({
      totalRevenue,
      totalExpenses,
      ownerSharePercentage: ownerShareRaw,
      unitCount: (pkg.units || []).length,
      unitAvailableDays: report && report.unitAvailableDays,
      totalAvailableDays: report && report.totalAvailableDays,
      groupingType,
      installmentDeducted: 0,
      shareType: pkg.shareType || (report && report.shareType) || 'share-by-profit',
      expenseBuckets,
    });
    const ownersRevenue = waterfall.ownersRevenue;
    const ownerBorne = waterfall.ownerBorneExpenses;
    const ownerNet = waterfall.nettOwnersProfit;
    const hostRevenue = Number((totalRevenue - ownersRevenue).toFixed(2));
    const hostBorne = Number((totalExpenses - ownerBorne).toFixed(2));
    const hostNet = Number((hostRevenue - hostBorne).toFixed(2));
    const unitId = String((report && (report.unit || report.unitId)) || '');
    const meta = unitMeta[unitId] || {};
    return {
      Owner: ownerNameOf(report),
      'Property Name': propertyName || (report && report.propertyName) || meta.propertyName || '',
      'Room Type': meta.roomTypeName || '',
      Unit: (report && report.unitName) || meta.unitName || unitId,
      'Total Revenue After Platform Fee': csvMoney(totalRevenue),
      'Host Revenue': csvMoney(hostRevenue),
      "Owner's Revenue": csvMoney(ownersRevenue),
      'Total Expenses': csvMoney(totalExpenses),
      'Host Borne Expense': csvMoney(hostBorne),
      'Owner Borne Expense': csvMoney(ownerBorne),
      'Host Net Profit': csvMoney(hostNet),
      'Owner Net Profit': csvMoney(ownerNet),
      'Administrative Charges': csvMoney(0),
      'Host Charge': csvMoney(0),
      'Host Charge (Hidden)': csvMoney(0),
      Currency: (report && report.currency) || 'MYR',
    };
  });

  const keysToRemove = OPTIONAL_COLUMNS.filter(key => rows.every(row => Number(row[key]) === 0));
  rows.forEach(row => {
    keysToRemove.forEach(key => {
      delete row[key];
    });
  });
  return rows;
};
